import type { FlexProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslations } from '@ui/i18n';
import { format } from 'date-fns';
import type { FC } from 'react';

export type DateRangeIndicatorProps = FlexProps & {
  selectedDate: Date[];
};
export const DateRangeIndicator: FC<DateRangeIndicatorProps> = ({
  selectedDate,
  ...props
}) => {
  const t = useTranslations();
  const fromDate = selectedDate[0];
  const toDate = selectedDate[1];
  return (
    <Flex alignItems="center" {...props}>
      <Text mr="4px">{t('From')}</Text>
      <Text textStyle={fromDate ? 'bodyBold' : 'body'}>
        {fromDate ? format(fromDate, 'yyyy-MM-dd') : '-'}
      </Text>
      <Text ml="16px" mr="4px">
        {t('To')}
      </Text>
      <Text textStyle={toDate ? 'bodyBold' : 'body'}>
        {toDate ? format(toDate, 'yyyy-MM-dd') : '-'}
      </Text>
    </Flex>
  );
};
